export default {
    label_task:{
        en:"Market Requirement",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Market Requirement",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Market Requirement",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Market Requirement",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_crop_id:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },
    label_crop_name:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },

    label_crop_type2_id:{
        en:"Type",
        bn:"কর্মচারী আইডি"
    },
    label_crop_type2_name:{
        en:"Type",
        bn:"কর্মচারী আইডি"
    },
    label_part_id:{
        en:"Part",
        bn:"কর্মচারী আইডি"
    },
    label_part_name:{
        en:"Part",
        bn:"কর্মচারী আইডি"
    },
    label_area_id:{
        en:"Area",
        bn:"কর্মচারী আইডি"
    },
    label_area_name:{
        en:"Area",
        bn:"কর্মচারী আইডি"
    },
    label_territory_id:{
        en:"Territory",
        bn:"কর্মচারী আইডি"
    },
    label_territory_name:{
        en:"Territory",
        bn:"কর্মচারী আইডি"
    },

}